// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2VB61","cell":"ColumnAccessor_cell__1ifiv","firstCellAccent":"ColumnAccessor_firstCellAccent__2FZyN"};